import axios, { Method } from "axios";
import { useEffect, useRef, useState } from "react";
import { all_routes } from "../../feature-module/router/all_routes";
import { clearAuthToken, getBearerToken } from "../../utils/authToken";

interface AxiosProps {
  url: string;
  method: Method;
  data?: any;
  params?: any;
  headers?: any;
}

export const useAxios = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<any>(null);
  const [response, setResponse] = useState<any>(null);
  const controllerRef = useRef<AbortController | null>(null);

  // Full API URLs come from webServiceUrl; no baseURL here (matches axiosConfigMethod).
  const axiosInstance = axios.create({
    timeout: 20000,
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      return config;
    },
    (error: any) => Promise.reject(error),
  );

  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error: any) => Promise.reject(error),
  );

  // let controller = new AbortController();
  useEffect(() => {
    // return () => controller?.abort();
    return () => controllerRef.current?.abort();
  }, []);

  const request = async ({
    url = "",
    method = "GET",
    data = {},
    params = {},
    headers = {},
  }: AxiosProps) => {
    // controller?.abort();
    // controller = new AbortController();
    controllerRef.current?.abort();
    controllerRef.current = new AbortController();
    const token = getBearerToken();

    setLoading(true);
    setErrors(null);

    const reqData = {
      url,
      method,
      data,
      params,
      signal: controllerRef.current.signal,
      headers: {
        ...headers,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    };

    try {
      const result = await axiosInstance(reqData);
      // console.log(result);
      setResponse(result.data);
      return result.data;
    } catch (error: unknown) {
      if (!axios.isAxiosError(error)) {
        console.error("Non-Axios Error:", error);
        setErrors(error);
        throw error;
      }
      if (error.code == "ERR_CANCELED") {
        // console.error("cancelled request:", error);
        return;
      }

      const status = error.response?.status;
      const isLoginRequest = url.includes("/admin-login");
      if (
        (status === 401 || status === 403) &&
        !isLoginRequest &&
        window.location.pathname !== all_routes.login
      ) {
        clearAuthToken();
        window.location.href = all_routes.login;
        return;
      }

      // Network/timeout failures (no HTTP response received).
      const isNetworkFailure =
        error.code === "ERR_NETWORK" || error.code === "ECONNABORTED";
      if (
        isNetworkFailure &&
        !isLoginRequest &&
        process.env.NODE_ENV === "production" &&
        window.location.pathname !== all_routes.error500
      ) {
        window.location.href = all_routes.error500 ?? "/error-500";
        return;
      }
      if (isNetworkFailure && isLoginRequest) {
        const apiHint = url.includes("superadmin.nestfin.app")
          ? "Cannot reach the API. Check Nginx /api→9090 and that superadmin_cloud is running."
          : "Cannot reach the server. Is the backend running?";
        setErrors({ message: apiHint });
        throw Object.assign(error, { userMessage: apiHint });
      }
      setErrors(error?.response?.data || error?.request || error?.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    request,
    loading,
    data: response,
    errors,
  };
};

// catch (error: unknown) {
//       //   setErrors(error.response ? error.response.data : error.message);

//       if (!axios.isAxiosError(error)) {
//         if
//         console.error("Non-Axios Error:", error);
//         setErrors(error);
//         throw error;
//       }
//       setErrors(error?.response?.data || error?.request || error?.message);
//       // if (error.response) {
//       //   return {
//       //     data: error.response.data,
//       //     status: error.response.status,
//       //     headers: error.response.headers,
//       //   };
//       // }
//       // if (error.request) {
//       //   console.error("No response", error.request);
//       // } else {
//       //   console.error("Axios error: ", error.message);
//       // }
//       throw error;
//     } finally {
//       setLoading(false);
//     }
